export { default } from './head.js'



//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/lodash-es/first.js
// module id = 242
// module chunks = 0